export default __webpack_public_path__ + "static/media/services-metabolic.23ad8534.jpg";